<template>
    <div class="configure-container">
        <div class="configure-title-section">
            <div>
                <div class="back-link " @click="goBackClick()"> {{'< BACK'}} </div>
                <div class="configure-title">Configure Programs</div>
                <div class="configure-subtitle" style= "margin-left: 28px;font-weight:10px;padding-bottom:20px">Edit or delete programs. Mark them as active or in-active.</div>
            </div>
            <div style="margin-right: 20px;">
                <input type="text" placeholder="Search Program" v-model="searchTerm" class="search-metrics"/>
                <img  style="margin-top: 4px; margin-left: -40px; margin-right: 65px; padding: 10px 0px 14px;width:22px;" src="../assets/img/search-logo.png" alt="search-metrics"/>
            </div>
        </div>
        <div class="configure-view-section relativePos" :style="{height: `${maxHeight - 214}px`}">
            <overlay-loader :isLoading="editProgramLoadingState"></overlay-loader>
            
            <div class="program-configure-read">
                <div class="metric-form">
                    <div class="form-field-aarp" style="width: 150px">
                        <!--<font-awesome-icon style="color: #2B779C; height: 20px; padding: 2px;" icon="trash-alt"> </font-awesome-icon>-->
                        <div class="filter-label">Year</div>
                        <div style="width:160px; display: flex;">
                    <div>
                        <div style="margin-bottom:8px; margin-left: 4px;margin-top: 6px;width: 160px">
                                <datepicker :calendar-class="'vdp-datepicker'" input-class='datePicker-input-class' :value="modalSelectedYear" 
                                v-model="modalSelectedYear" :disabled="!years" placeholder="Select Year" @selected="setYear()" 
                                @opened="displayRequiredYears()" 
                                name="years"  :minimum-view="'year'" :format="'YYYY'" :maximum-view="'year'" 
                                :initial-view="'year'" :disabled-dates="disabledDates"></datepicker>
                            </div>
                            <div v-if="!years">
                                <img style="margin-top: -160px; margin-left: 215px;padding: 120px 0px 140px; width:26px;" src="../assets/img/ajax-loader.gif" alt="loading data..." />
                            </div>
                    </div>
                        </div>
                    </div>
                    <div class="form-field-aarp" style="align-self: flex-end;">
                        <button @click="viewMetrics()" :disabled="true || !modalSelectedYear" class="btn btn btn-action-arp" style="visibility: hidden">Add Program</button>
                    </div>
                </div>
                <div class="metric-data-view" v-if="modalSelectedYear">
                    <div v-if="hotSettings.data.length > 0" style="margin-top: 24px;">
                        <HotTable :settings="hotSettings" ref="hotTableComponent" :style="{ height: `${maxHeight - 414}px`, overflow: 'auto'}"></HotTable>
                        <!--
                        <div id="advanced-editor-example" class="hot">
                            <hot-table :settings="hotSettings">
                                <hot-column :width="150">
                                    <p hot-renderer>111</p>
                                </hot-column>
                                <hot-column v-for="n in 2" :width="150" v-bind:key="'col' + n">
                                    <p hot-renderer>222</p>                            
                                </hot-column>
                            </hot-table>
                        </div> -->
                    </div>
                    <div v-if="hotSettings.data.length === 0" style="margin-top: 24px;">
                        Please Wait...
                    </div>
                </div>
            </div>
            <div class="program-configure-write">
                 <div v-if="renderEditSection" class="metric-edit-main">
                        <div class="metric-view-title" style="font-size: 22px;">Edit Program</div>
                        <div style="margin-bottom: 20px;">
                            <div class="filter-label">Program Name:</div>
                            <div>
                                <input class="category-input" type="text" v-model="editedProgramName" />
                            </div>
                        </div>
                        <div style="border-top: 1px solid #C0C0C0; width:320px; margin-bottom: 20px;"></div>
                        <div style="margin-left: 60px;">
                        <button @click="closeMetricEdit()" class="btn btn-action-arp" style="width: 90px;">Cancel</button>
                        <button class="btn btn-warning-arp" @click="onEditProgramName" style="width: 90px;">Save</button>
                        </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { HotTable, HotColumn } from '@handsontable-pro/vue';
import { mapActions, mapGetters } from 'vuex';
import Handsontable from 'handsontable-pro';
import "handsontable-pro/dist/handsontable.full.css";
import { parse } from 'path';
import Datepicker from '@hokify/vuejs-datepicker';
import { LICENSE_KEY } from "../Constants"
import OverlayLoader from './OverlayLoader';

const editImageSource = 'src/assets/img/edit-24px.svg';

export default {
  name: "MetricConfiguration",
  components: {
        HotTable,
        HotColumn,
        'datepicker':Datepicker,
        overlayLoader: OverlayLoader
        },
  methods: {
       ...mapActions(['login','getCommentsData','updateComments','updateOverlayParams','initDeleteComment','editProgramStatus','updateGetMetricParams','updateCommentaryParams','postEditComment','getMenuOptions','resetOverlay','getProgramData','editProgramName']),
      goBackClick() {
            this.$router.push({name: 'Configuration'});
      },
      onEditProgramName() {
          const data = {
                new_program_name: this.editedProgramName,
                existing_program_name: this.categoryValue,
                year: JSON.stringify(this.modalSelectedYear.getUTCFullYear()),
          };
          if (this.editedProgramName !== this.categoryValue) {
              this.editProgramName(data);
              this.updateGetMetricParams({program: this.editedProgramName, year: this.modalSelectedYear.getUTCFullYear()});
          }
          this.renderEditSection = false;
      },
      viewMetrics() {
          if (this.modalSelectedYear) {
              this.metricData = true;
          }
      },
      doIt(val, cords, c, d) {
          var htTable =  this.$refs.hotTableComponent.hotInstance.getInstance();
          this.editSelection = {...this.hotSettings.data[htTable.toPhysicalRow(cords.row)]};
          this.categoryValue = this.editSelection.program;
          this.editedProgramName = (' ' + this.categoryValue).slice(1);
          this.renderEditSection = true;
        },
        deleteProgram(e, cords, td) {
            this.resetOverlay();
            const _this = this;
            var htTable =  this.$refs.hotTableComponent.hotInstance.getInstance();
            let editSelection = {...this.hotSettings.data[htTable.toPhysicalRow(cords.row)]};
            this.updateGetMetricParams({program: editSelection.program, year: this.modalSelectedYear.getUTCFullYear()});
            this.updateOverlayParams({
                display: 'block',
                title: 'Delete Program',
                message: 'Are you sure you want to delete this Program?',
                isNotification: false,
                buttons: {
                    type: 'challenge',
                    successHandler: () => {
                        const body = {
                            "program_status": 'deleted'
                        };
                    _this.editProgramStatus(body);
                    }
                },
                specialClassNames: 'delete-comment',
                duration: '',
                displayCloseIcon: true,
                background: true
            });
        },
    closeMetricEdit() {
        this.renderEditSection = false;
    },
     setYear(){ 
            this.modalselectedYear=new Date().getFullYear().toString();
             this.renderEditSection = false;
         },
    displayRequiredYears(){
        let years=JSON.stringify(Object.keys(this.years))
        this.disabledDates.customPredictor= function(date) {
        if(years.toString().includes(date.getFullYear())){
                return false;
            }
            else{
                return true;
            }
        }
    },
    handleStatusChange(e, cords, td) {
        let data = [...this.hotSettings.data];
        var htTable =  this.$refs.hotTableComponent.hotInstance.getInstance();
        let editSelection = {...this.hotSettings.data[htTable.toPhysicalRow(cords.row)]};
        if (data[htTable.toPhysicalRow(cords.row)].status.toLowerCase() === 'active') {
            data[htTable.toPhysicalRow(cords.row)].status = 'In-active';
        } else {
            data[htTable.toPhysicalRow(cords.row)].status = 'Active';
        }
        this.updateGetMetricParams({program: editSelection.program, year: this.modalSelectedYear.getUTCFullYear()});
         const body = {
                "program_status": data[htTable.toPhysicalRow(cords.row)].status.toLowerCase()
            };
        this.editProgramStatus(body);
        this.hotSettings.data = [...data];
    },
    searchInResults: function(searchTerm) {
        if(this.hotSettings.data!=='undefined' && this.hotSettings.data.length>0)
        {
            if(searchTerm.length>0)
            {
                 const filtersPlugin = this.$refs.hotTableComponent.hotInstance.getPlugin('filters');
                 filtersPlugin.removeConditions(0);
                 filtersPlugin.filter();
                 filtersPlugin.addCondition(0, 'contains', [searchTerm]);
                 filtersPlugin.filter();
                 var htTable =  this.$refs.hotTableComponent.hotInstance.getInstance();
                              if(htTable.countVisibleRows()==0)
                {
                      this.$notify({
                         group: 'error',
                         text: 'Result not found...',
                         closeOnClick:true
                         });
                }
            }
            else
            {
                 const filtersPlugin = this.$refs.hotTableComponent.hotInstance.getPlugin('filters');
                 filtersPlugin.removeConditions(0);
                 filtersPlugin.filter();
            }
        }
        else{
             if(searchTerm.length>0)
            {
             this.$notify({
                             group: 'error',
                             text: 'Select year and program name for searching...',
                             closeOnClick:true
                             });
             }
       }
    }
   },
  data: function() {
    let _this = this;
    return {
        maxHeight: innerHeight,
        editedProgramName: '',
        searchTerm: '',
        years: false,
        modalPrograms: '',
        editSelection: {},
        categoryValue: '',
        decimalValue: 12,
        modalSelectedYear: '',
        modalSelectedProgram: '',
        metricData: false,
        renderEditSection: false,
        sortState: null,
        disabledDates:{ customPredictor: function(date) {
                if(typeof this.years!=='undefined'){
            if(this.years.toString().includes(date.getFullYear())){
                    return false;
                }
                else{
                    return true;
                }
            }}},
        hotSettings: {
                data: [
                    /*
                    ['t', '12', 'A', '2.34'],
                    ['t', '12', 'A', '2.34'],

                    ['t', '12', 'A', '2.34'],

                    {
                        program: 'AT&T',
                        category: '1',
                        status: 'Active',
                        decimals: '0.876'
                    }
                    */
                ],
                licenseKey: LICENSE_KEY,
                colHeaders: ['Program', 'Status', 'Actions'],  
                columnSorting: {
                    indicator: true,
                    initialConfig: null
                },
                afterColumnSort(currentSortConfig, destinationSortConfigs) {
                    _this.sortState = destinationSortConfigs[0];
                },
                columns: [
                    {
                        data: 'program',
                        readOnly: true,
                        width: 210,
                        editor: false
                    },
                    {
                        data: 'status',
                        readOnly: true,
                        width: 235,
                          renderer: function(instance, td, row, col, prop, value, cellProperties) {
                            Handsontable.renderers.TextRenderer.apply(this, arguments);
                            let escaped = Handsontable.helper.stringify(value);
                            td.innerHTML = value.toLowerCase() == 'active' ? `<div style="padding-top: 5px; color:white !important; font-size: 10px;"><label class="switch"><input type="checkbox" checked><span class="slider round" style="margin-left:10px; width:60px; padding-left: 5px;" slot="Active">Active</span></label></div>` : `<div style="padding-top: 5px; font-size: 9px;right: 200px"><label class="switch"><input type="checkbox" ><span class="slider round" style= "width:60px; padding-left: 20px; margin-left:10px;" slot="In-active">In-active</span></label></div>`;
                          },
                        editor: false
                    },
                    {
                        data: 'actions',
                        width: 158,
                        editor: false,
                        renderer: function(instance, td, row, col, prop, value,
                        cellProperties) {
                            Handsontable.renderers.TextRenderer.apply(this, arguments);
                            let escaped = Handsontable.helper.stringify(value);
                       /* td.innerHTML = `<div style="display: flex;flex-direction: row;
    justify-content: space-between;"> <div>${value}</div> <div class="decimal-cell-buttons"> <div><img src=${editImageSource} alt="edit"/></div> <div class="svg-button-ht" style="background-image: url(${editImageSource}); width: 30px;"> </div> </div> </div>`;
                        td.className = 'test-1' */
                        td.innerHTML = `<div style="display: flex;flex-direction: row;    justify-content: flex-end;"> <div class="decimal-cell-buttons" style="width: 35px; cursor: pointer;"> <div class="action-1"><svg style="padding: 0px; height: 20px; color: #2B779B" data-v-30a07fb4="" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="pencil-alt" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-pencil-alt fa-w-16" style="color: blue;"><path data-v-30a07fb4="" class="svg-inline--fa fa-pencil-alt fa-w-16" fill="currentColor" d="M497.9 142.1l-46.1 46.1c-4.7 4.7-12.3 4.7-17 0l-111-111c-4.7-4.7-4.7-12.3 0-17l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0l60.1 60.1c18.8 18.7 18.8 49.1 0 67.9zM284.2 99.8L21.6 362.4.4 483.9c-2.9 16.4 11.4 30.6 27.8 27.8l121.5-21.3 262.6-262.6c4.7-4.7 4.7-12.3 0-17l-111-111c-4.8-4.7-12.4-4.7-17.1 0zM124.1 339.9c-5.5-5.5-5.5-14.3 0-19.8l154-154c5.5-5.5 14.3-5.5 19.8 0s5.5 14.3 0 19.8l-154 154c-5.5 5.5-14.3 5.5-19.8 0zM88 424h48v36.3l-64.5 11.3-31.1-31.1L51.7 376H88v48z" class=""></path></svg></div> </div> <div class="delete-program-button action-2" id="deleteProgram" style="width: 20px; cursor: pointer;"><svg data-v-12273041="" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="trash-alt" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-inline--fa fa-trash-alt fa-w-14" style="color: rgb(43, 119, 156); height: 20px; padding: 0px;"><path class="svg-inline--fa fa-trash-alt fa-w-14" data-v-12273041="" fill="currentColor" d="M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm272-256a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z" class=""></path></svg></div></div>`;
                        return td;
                        }
                    }
                ],
                afterOnCellMouseDown: function(event, cords, TD) {
                    if (event && event.target && event.target.className == "slider round") {
                        _this.handleStatusChange(event, cords, TD);
                        return;
                    }
                    let classname = event && event.realTarget && event.realTarget.className && event.realTarget.className.baseVal && event.realTarget.className.baseVal.toString().trim();
                    if (classname === "svg-inline--fa fa-trash-alt fa-w-14") {
                        _this.deleteProgram(event, cords, TD)
                        return;
                    }
                     if (classname === "svg-inline--fa fa-pencil-alt fa-w-16") {
                        _this.doIt(event, cords, TD);
                        return;
                    }
                    //_this.doIt(event, cords, TD);
                   /* if (event.realTarget.className.indexOf('myBt') < 0 && event.realTarget.className.indexOf('delete') < 0) {
                        return;
                    }
                    event.realTarget.className.indexOf('myBt') === 0 && _this.doIt();
                    event.realTarget.className.indexOf('delete') === 0 && _this.deleteMetric();
                    */
                },
                renderer: 'html',
                autoRowSize: false,
                autoColumnSize: false,
                disableVisualSelection: true,
                filters: true
            },
    };
  },
  computed: mapGetters(['currentCommentsMainCategory','currentCommentsSubCategory','currentCommentsYear','currentCommentsPeriod','currentCommentsData','isLoggedIn','currentUserName','currentUserEmail','currentUserGroups','currentAccessLevel','currentCommentaryMenu', 'programData', 'editProgramLoadingState']),
  watch: {
      currentCommentaryMenu: function(){
            this.years = this.currentCommentaryMenu;
        },
      programData: function() {
          this.modalPrograms = [...this.programData];
          let dd = [];
        this.modalPrograms.forEach(element => {
            let obj = {};
            obj['program'] = element.program_name;
            obj['status'] = element.program_status;
            obj['id'] = element.id;
            dd.push(obj);
        });
        
        this.hotSettings.columnSorting.initialConfig = this.sortState;
        this.hotSettings.data = dd;
      },
      searchTerm: function()
      {
          this.searchInResults(this.searchTerm);
      },
      modalSelectedYear: function(){
            this.getProgramData(this.modalSelectedYear.getUTCFullYear())
            this.modalPrograms = [];
            if (this.modalSelectedYear.getUTCFullYear().toString().length > 0){
                // this.modalPrograms = this.years[this.modalSelectedYear]['Providers'];
                let dd = [];
                this.modalPrograms.forEach(element => {
                    let obj = {};
                    obj['program'] = element;
                    obj['status'] = 'Active';
                    dd.push(obj);
                });
                this.hotSettings.columnSorting.initialConfig = this.sortState;
                this.hotSettings.data = dd;
            }
        },
  },
  created(){
        this.getMenuOptions();
  }
};
</script>

<style>
.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 18px;
}

.switch input { 
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 14px;
  width: 14px;
  left: 3px;
  bottom: 2px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #2B779B
}

input:focus + .slider {
  box-shadow: 0 0 1px #2B779B;
}

input:checked + .slider:before {
  -webkit-transform: translateX(33px);
  -ms-transform: translateX(33px);
  transform: translateX(33px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>

<style scoped>
.selection-item {
    font-size: 14px;
}
.decimal-box {
    display: flex;
    border: 1px solid #C0C0C0;
}
.decimal-action-button {
    width: 60px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #E7EAF2;
    cursor: pointer;
    font-size: 18px;
    font-weight: bold;
}
.decimal-input {
    width: 130px;
    height: 40px;
    text-align: center;
    border-radius:5px;
}
.category-input {
    width: 320px;
    height: 40px;
    padding: 6px 9px;
}
.edit-selection {
    display: flex;
    flex-direction: row;
    margin-top: 25px;
}
.metric-edit-main {
    display: flex;
    flex-direction: column;
    margin-top: 28px;
}
.program-configure-read {
    width: 700px;
    padding-top: 24px;
    padding-left: 24px;
    padding-right: 24px;
    background-color: #F4F4F4;
    height: inherit;
}
.program-configure-write {
    width: 800px;
    padding: 20px;
    /* margin-top: 16px; */
    border-left: 2px solid #C0C0C0;
    height: inherit;
    padding-top: 24px;
    padding-left: 24px;
    padding-right: 24px;
    background-color: #EEEEEE;
}
.handsontable .decimal-cell {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}
.metric-data-view {
    margin-top: 30px;
}
.metric-view {
    display: flex;
    justify-content: space-between;
    width: 100%;
}
.metric-view-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: bold;
    font-size: 18px;
 }
.form-field-aarp {
    margin-right: 24px;
}
.metric-form {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}
.btn-action-arp {
    color: #000 !important;
    font-weight: bold !important;
    height: 34px;
    bottom: -2px;
    position: relative;
    padding: 3px 10px;
    width: 134px;
    background-color: #ffffff;
    border: 1px solid #c0c0c0;
    border-radius:5px;
}
.btn-warning-arp {
    color: #000 !important;
    background-color: #FBC743 !important;
    font-weight: bold !important;
    height: 34px;
    bottom: -2px;
    position: relative;
    padding: 3px 10px;
    width: 150px;
    border-radius:5px;

}
.filter-label {
    font-weight: bold;
    margin-bottom: 2px;
    margin-top: 26px;
}
.form-title {
    font-size: 18px;
    font-weight: bold;
    padding-bottom: 20px;
    border-bottom: 2px solid #eeeeee;
    margin-bottom: 20px;
}
.search-metrics {
    border-radius: 30px;
    width: 300px;
    padding-left: 20px;
    border: 0;
    border: 1px solid #B1B9BE;
    height: 40px;
}
.search-metrics:focus {
    outline: none;
}
.back-link {
    color: rgb(43, 119, 155);
    cursor: pointer;
    padding: 3px 10px;
    font-size: 15px;
    font-weight: bold;
    margin-left: 20px;
    margin-top: 20px;
}
.configure-container {
  font-family: Arial;
  font-size: 16px;
  height: 100%;
}
.configure-title-section {
  top: 60px;
  left: 0px;
  width: 100%;
  height: 130px;
  background: #ffffff 0% 0% no-repeat padding-box;
  opacity: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.configure-title {
  margin-left: 28px;
  font-size: 26px;
  font-weight: 300;
  margin-top: 10px;
}
.configure-view-section {
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  background-color: #eeeeee;
  margin: 0;
  padding: 0;
  /* height: 82vh; */;
}

.relativePos {
    position: relative;
}

</style>
